import { render, staticRenderFns } from "./selected-related-tags.vue?vue&type=template&id=48460a94&"
import script from "./selected-related-tags.vue?vue&type=script&lang=ts&"
export * from "./selected-related-tags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports